export default __webpack_public_path__ + "static/media/luki 1.b04a0c32.png";